








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryWithdrawMerchantBalanceStatList,ExportWithdrawMerchantBalanceStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class WithdrawMerchantBalanceStatList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '期初已提现总额', param: 'beginTotalWithdraw' },
    { title: '期末已提现总额', param: 'endTotalWithdraw' },
    { title: '今日提现总额', param: 'todayTotalWithdraw' },
    { title: '申请中数量', param: 'applyingCount' },
    { title: '申请中金额', param: 'applyingAmount' },
    { title: '审核通过数量', param: 'approvedCount' },
    { title: '审核通过金额', param: 'approvedAmount' },
    { title: '审核拒绝数量', param: 'rejectedCount' },
    { title: '审核拒绝金额', param: 'rejectedAmount' },
    { title: '连连可用余额（商户）', param: 'directShopAvailableBalanceLianlian' },
    { title: '连连待结算余额（商户）', param: 'directShopPendingSettlementBalanceLianlian' },

    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      fixed: 'right',
      width: 280,
      operation: [
        { title: '提现成功明细' , click: this.jumpTo1 },
        { title: '审核通过明细' , click: this.jumpTo2 },
        { title: '审核拒绝明细' , click: this.jumpTo3 },
      ],
    },
  ]

  private jumpTo1(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/withdrawAuditList",
      query:{
        withdrawSuccessTime: data.statDate,
        withdrawStatus: '4'
      }
    })
  }
  private jumpTo2(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/withdrawAuditList",
      query:{
        applyPassTime: data.statDate,

      }
    })
  }
  private jumpTo3(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/withdrawAuditList",
      query:{
        withdrawRejectTime: data.statDate,
        withdrawStatus: '2'
      }
    })
  }


  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportWithdrawMerchantBalanceStat(param,"每日提现数据统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryWithdrawMerchantBalanceStatList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
